import { HowTo as HowToSchema } from 'schema-dts';

import { HowTo as HygraphHowTo } from '@/lib/types';

import GenericHowTo from '@/components/generic-how-to';
import { buildHowToSpecialtyItems } from '@/components/how-to-specialty';

import howToTransformer from '@/hygraph/transformers/how-to.transformer';
import { TSchemaContext, TSchemaData } from '@/services/schema-service';

export default function HowToRenderer(props: HygraphHowTo) {
  return <GenericHowTo {...howToTransformer(props)} />;
}

HowToRenderer.buildSchema = (
  props: HygraphHowTo,
  { specialty }: TSchemaContext = {}
): Partial<TSchemaData<HowToSchema>> => ({
  things: [
    {
      '@context': 'https://schema.org',
      '@type': 'HowTo',
      name: props.title || '',
      step: buildHowToSpecialtyItems({
        specialty,
      }).map((itemProps) => ({
        '@type': 'HowToStep',
        name: itemProps.title,
        text: itemProps.subtitle,
        url: itemProps.href,
        image: itemProps.iconUrl,
      })),
    },
  ],
});
